/* eslint-disable no-loop-func */
/* eslint-disable no-await-in-loop */
import React, { FC, useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import BitInput from '../BitInput/BitInput';
import BitButton from '../BitButton/BitButton';
import { endpointState } from '../../recoil/atoms';
import BitLinkButton from '../BitLinkButton/BitLinkButton';

type ModalNewScheduleProps = {
	isOpen: boolean;
	handleClose: () => void;
};
export const ModalNewSchedule: FC<ModalNewScheduleProps> = ({
	isOpen,
	handleClose,
}) => {
	const { urlEndpoint } = useRecoilValue(endpointState);
	const [showCarregandoTabela, setShowCarregandoTabela] = React.useState(
		'hidden',
	);

	const [date, setDate] = React.useState({
		value: '',
		required: true,
	});

	const [empreendimentos, setEmpreendimentos] = React.useState({
		value: [],
		required: true,
	});

	const [freeHours, setFreeHours] = React.useState({
		value: [],
		required: true,
	});

	const [calendars, setCalendars] = React.useState({
		value: [],
		required: true,
	});
	const [users, setUsers] = React.useState({
		value: [],
		required: true,
	});

	const [selectedHour, setSelectedHour] = React.useState('');

	const [
		empreendimentoSelecionado,
		setEmpreendimentoSelecionado,
	] = React.useState<any>(null);

	const [calendarSelected, setCalendarSelected] = React.useState('');

	const [selectedUser, setSelectedUser] = React.useState('');

	const fetchDevelopments = async () => {
		const token = localStorage.getItem('token');
		setShowCarregandoTabela('');
		await axios
			.get(`${urlEndpoint}/developments`, {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			})
			.then(function (response) {
				const allEmpreendimentos = response.data.data.data;
				setEmpreendimentos({
					value: allEmpreendimentos.map((empreendimento: any) => {
						return {
							value: empreendimento.id,
							label: empreendimento.name,
							selected: false,
						};
					}),
					required: empreendimentos.required,
				});
			})
			.catch((error: any) => {
				console.log(error);
				toast.error(
					`Erro ao buscar empreendimentos\n\nError: ${error}`,
					{
						position: 'bottom-right',
						autoClose: 3000,
						hideProgressBar: true,
						closeOnClick: false,
						pauseOnHover: true,
						draggable: false,
						progress: undefined,
					},
				);
			})
			.finally(() => {
				setShowCarregandoTabela('hidden');
			});
	};

	const fetchCalendars = async (developmentId: string) => {
		const token = localStorage.getItem('token');

		await axios
			.get(`${urlEndpoint}/calendars`, {
				headers: {
					Authorization: `Bearer ${token}`,
				},
				params: {
					development: developmentId,
					development_id: developmentId,
				},
			})
			.then(function (response) {
				const allCalendars = response.data.data.data;
				setCalendars({
					value: allCalendars.map((calendar: any) => {
						return {
							value: calendar.id,
							label: calendar.name,
							selected: false,
						};
					}),
					required: calendars.required,
				});
			})
			.catch((error: any) => {
				console.log(error);
				toast.error(`Erro ao buscar áreas comuns\n\nError: ${error}`, {
					position: 'bottom-right',
					autoClose: 3000,
					hideProgressBar: true,
					closeOnClick: false,
					pauseOnHover: true,
					draggable: false,
					progress: undefined,
				});
			});
	};

	useEffect(() => {
		if (isOpen) fetchDevelopments();
	}, [isOpen]);

	const handleFetchFreeHours = async () => {
		const token = localStorage.getItem('token');
		setShowCarregandoTabela('');

		await axios
			.get(`${urlEndpoint}/bookings/${calendarSelected}`, {
				headers: {
					Authorization: `Bearer ${token}`,
				},
				params: {
					date: date.value,
				},
			})
			.then(function (response) {
				const allFreeHours = response.data.data;
				setFreeHours({
					value: allFreeHours.map((freeHour: any) => {
						return {
							value: freeHour.time,
							label: freeHour.time,
							range: freeHour.range,
							selected: false,
						};
					}),
					required: freeHours.required,
				});
			})
			.catch((error: any) => {
				console.log(error);
				toast.error(`Erro ao buscar horários\n\nError: ${error}`, {
					position: 'bottom-right',
					autoClose: 3000,
					hideProgressBar: true,
					closeOnClick: false,
					pauseOnHover: true,
					draggable: false,
					progress: undefined,
				});
			})
			.finally(() => {
				setShowCarregandoTabela('hidden');
			});
	};

	const addMinutesToTime = (startHour: string, minutesToAdd: number) => {
		const [hours, minutes] = startHour.split(':').map(Number); // Divide e converte para números
		const totalMinutes = hours * 60 + minutes + minutesToAdd; // Converte tudo para minutos e soma
		const newHours = Math.floor(totalMinutes / 60) % 24; // Garante que as horas fiquem dentro de 0-23
		const newMinutes = totalMinutes % 60;

		// Formata para HH:mm com zero à esquerda se necessário
		return `${String(newHours).padStart(2, '0')}:${String(
			newMinutes,
		).padStart(2, '0')}`;
	};

	const handleCreateSchedule = async () => {
		const token = localStorage.getItem('token');
		setShowCarregandoTabela('');

		const range =
			freeHours.value.find(
				(hour: any) => hour.value === selectedHour,
				// @ts-ignore
			)?.range || 0;

		await axios
			.post(
				`${urlEndpoint}/bookings/store`,
				{
					date: date.value,
					start_time: selectedHour,
					end_time: addMinutesToTime(selectedHour, range),
					user_id: selectedUser,
					calendar_id: calendarSelected,
				},
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
					params: {
						isApp: false,
					},
				},
			)
			.then(function (response) {
				console.log(response);
			})
			.catch((error: any) => {
				console.log(error);
				toast.error(`Erro ao criar agendamento\n\nError: ${error}`, {
					position: 'bottom-right',
					autoClose: 3000,
					hideProgressBar: true,
					closeOnClick: false,
					pauseOnHover: true,
					draggable: false,
					progress: undefined,
				});
			})
			.finally(() => {
				resetSelectedFields();
				setShowCarregandoTabela('hidden');
			});
	};

	const fetchUsers = async (developmentId: string) => {
		const token = localStorage.getItem('token');
		const allUsers = [] as any[];
		let page = 1;
		let hasMore = true;

		setShowCarregandoTabela('');

		while (hasMore) {
			await axios
				.get(`${urlEndpoint}/users`, {
					headers: {
						Authorization: `Bearer ${token}`,
					},
					params: {
						development: developmentId,
						development_id: developmentId,
						type: 3,
						page,
					},
				})
				.then(function (response) {
					hasMore = !!response.data.data.data.length;
					page += 1;
					allUsers.push(...response.data.data.data);
				})
				.catch((error: any) => {
					console.log(error);
					toast.error(`Erro ao buscar moradores\n\nError: ${error}`, {
						position: 'bottom-right',
						autoClose: 3000,
						hideProgressBar: true,
						closeOnClick: false,
						pauseOnHover: true,
						draggable: false,
						progress: undefined,
					});
				});
		}

		setUsers({
			// @ts-ignore
			value: allUsers.map(user => {
				return {
					value: user.id,
					label: user.name,
					selected: false,
				};
			}),
			required: users.required,
		});

		setShowCarregandoTabela('hidden');
	};

	const resetSelectedFields = () => {
		setSelectedUser('');
		setSelectedHour('');
		setCalendarSelected('');
		setEmpreendimentoSelecionado('');
		setDate({ value: '', required: true });
		setEmpreendimentos({
			value: [],
			required: empreendimentos.required,
		});
		setUsers({
			value: [],
			required: users.required,
		});
		setCalendars({
			value: [],
			required: calendars.required,
		});
		setFreeHours({
			value: [],
			required: freeHours.required,
		});
	};

	return (
		<>
			<div className="bloco-campos-novo-cadastro">
				<div className="mb-4">
					<BitInput
						label="Empreendimento"
						type="select"
						multipleSelect={false}
						placeholder=""
						valuesSelect={empreendimentos.value}
						classField="grupo-campo-novos-registros"
						onChange={(e: React.FormEvent<HTMLSelectElement>) => {
							const allOptions = Object.entries(
								e.currentTarget.options,
							);

							allOptions.map(option => {
								if (option[1].selected) {
									setEmpreendimentoSelecionado(
										option[1].value,
									);
									fetchCalendars(option[1].value);
									fetchUsers(option[1].value);
								}
								return null;
							});
						}}
					/>
				</div>
				<div className="mb-4">
					<BitInput
						label="Morador"
						type="select"
						multipleSelect={false}
						placeholder=""
						valuesSelect={users.value}
						classField="grupo-campo-novos-registros"
						onChange={(e: React.FormEvent<HTMLSelectElement>) => {
							const allOptions = Object.entries(
								e.currentTarget.options,
							);

							allOptions.map(option => {
								if (option[1].selected) {
									setSelectedUser(option[1].value);
								}
								return null;
							});
						}}
					/>
				</div>
				<div className="mb-4">
					<BitInput
						label="Calendário"
						type="select"
						multipleSelect={false}
						placeholder=""
						valuesSelect={calendars.value}
						classField="grupo-campo-novos-registros"
						onChange={(e: React.FormEvent<HTMLSelectElement>) => {
							const allOptions = Object.entries(
								e.currentTarget.options,
							);

							allOptions.map(option => {
								if (option[1].selected) {
									setCalendarSelected(option[1].value);
								}
								return null;
							});
						}}
					/>
				</div>
			</div>
			<div className="bloco-campos-novo-cadastro">
				<div className="grid grid-cols-2 gap-4 mb-10">
					<BitInput
						label="Data"
						type="date"
						placeholder="Digite..."
						classField="grupo-campo-novos-registros"
						onChange={(e: React.FormEvent<HTMLInputElement>) =>
							setDate({
								value: e.currentTarget.value,
								required: true,
							})
						}
						value={date.value}
						required={date.required}
					/>
					<BitButton
						text={'Buscar Horários Disponíveis'}
						buttonColor={'#0077B6'}
						textColor={'#FFFFFF'}
						type={'fit px-10'}
						onClick={() => handleFetchFreeHours()}
						classesBlockOption={'inline-block'}
					/>
				</div>
			</div>
			<div className="bloco-campos-novo-cadastro">
				<div className="mb-4">
					<BitInput
						label="Horários Disponíveis"
						type="select"
						multipleSelect={false}
						placeholder=""
						valuesSelect={freeHours.value}
						classField="grupo-campo-novos-registros"
						onChange={(e: React.FormEvent<HTMLSelectElement>) => {
							const allOptions = Object.entries(
								e.currentTarget.options,
							);

							allOptions.forEach(option => {
								if (option[1].selected) {
									setSelectedHour(option[1].value);
								}
							});
						}}
					/>
				</div>
			</div>
			<div className="text-right">
				<BitButton
					text={'Fechar'}
					buttonColor={'#FFFFFF'}
					textColor={'#000000'}
					type={'fit px-10'}
					onClick={() => {
						resetSelectedFields();
						handleClose();
					}}
					classesBlockOption={'inline-block mr-2'}
				/>
				<BitButton
					text={'Criar Agendamento'}
					buttonColor={'#3AABA2'}
					textColor={'#FFFFFF'}
					type={'fit px-10'}
					classesBlockOption={'inline-block'}
					onClick={handleCreateSchedule}
				/>
			</div>
			<div className={`carregando-tabela ${showCarregandoTabela}`}>
				<i className="fas fa-spinner fa-spin" />
				<div className="background-carrega-tabela" />
			</div>
			<ToastContainer
				position="bottom-right"
				autoClose={2000}
				hideProgressBar
				newestOnTop={false}
				closeOnClick={false}
				rtl={false}
				pauseOnFocusLoss
				draggable={false}
				pauseOnHover
			/>
		</>
	);
};
